module.exports = __webpack_public_path__ + "static/media/car.1df2eea5.png";